
import RcDomainObject from "../../../common/RcDomainObject";
import Company from "../../company/Company.js";
import Employee from "../../employee/Employee.js";
import ChecklistItemResultMap from "../item/result/ChecklistItemResultMap.js";

import CheckList from "@/domain/model/checklist/CheckList.js";
import Vehicle from "@/domain/model/vehicle/Vehicle.js";

export default class ChecklistResult extends RcDomainObject {
  
  static MODEL_NAME = 'CheckListResult';
  
  static Fields = {
      CHECKLIST: CheckList.MODEL_NAME,
      COMPANY: Company.MODEL_NAME,
      VEHICLE: Vehicle.MODEL_NAME,
      EMPLOYEE: Employee.MODEL_NAME,
      DEFECT_TYPE: "defectType",
      RESULT_TYPE: "resultType",
      CHECKLIST_ITEM_RESULTS: ChecklistItemResultMap.MODEL_NAME,
  }
  
  constructor(domain, data) {
    super(domain, data, ChecklistResult.MODEL_NAME);
  }

  fields() {
    return ChecklistResult.FIELDS;
  }
  
  find() {
    var result = this.domain.checklists().results().findById(this.id());
    if (result.id() !== this.id()) {
      result = this;
    }
    return result;
  }

  checklist() {
    var data = this.get(ChecklistResult.Fields.CHECKLIST);
    return new CheckList(this.domain, data);
  }

  withChecklist(checklist) {
    this.put(ChecklistResult.Fields.CHECKLIST, checklist.data);
    return this;
  }

  withVehicle(vehicle) {
    this.put(ChecklistResult.Fields.VEHICLE, vehicle.data);
    return this;
  }

  withCompany(company) {
    this.put(ChecklistResult.Fields.COMPANY, company.data);
    return this;
  }

  withEmployee(employee) {
    this.put(ChecklistResult.Fields.EMPLOYEE, employee.data);
    return this;
  }
  
  withItemResults(itemResults) {
    this.put(ChecklistResult.Fields.CHECKLIST_ITEM_RESULTS, itemResults.data);
    return this;
  }

  vehicle() {
    var data = this.get(ChecklistResult.Fields.VEHICLE);
    return new Vehicle(this.domain, data);
  }

  company() {
    var data = this.get(ChecklistResult.Fields.COMPANY);
    return new Company(this.domain, data);
  }

  employee() {
    var data = this.get(ChecklistResult.Fields.EMPLOYEE);
    return new Employee(this.domain, data);
  }
  
  pointer() {
    var data = {'@rid': this.id()};
    var result = new ChecklistResult(this.domain, data);
    return result;
  }
  
  copy() {
    var data = this._copy();
    return new ChecklistResult(this.domain, data);
  }

  resultType() {
    return this.getString(ChecklistResult.Fields.RESULT_TYPE);
  }

  defectType() {
    return this.getString(ChecklistResult.Fields.DEFECT_TYPE);
  }

  withDefectType(defectType) {
    this.put(ChecklistResult.Fields.DEFECT_TYPE, defectType);
    return this;
  }

  itemResults() {
    var data = this.get(ChecklistResult.Fields.CHECKLIST_ITEM_RESULTS);
    return new ChecklistItemResultMap(this.domain, data);
  }

  addChecklistItemResult(itemResult) {
    let itemResults = this.itemResults();
    itemResults.addChecklistItemResult(itemResult);
    this.withChecklistItemResults(itemResults);
    return this;
  }

  withChecklistItemResults(itemResults) {
    this.put(ChecklistResult.Fields.CHECKLIST_ITEM_RESULTS, itemResults.data);
    return this;
  }

  load() {
    this.withChecklist(this.checklist().find());
    this.withCompany(this.company().find());
    this.withVehicle(this.vehicle().find());
    this.withEmployee(this.employee().find());
    let results = this.itemResults().find();
    results.load();
    this.withItemResults(results);
  }
}